<script lang="ts" setup>
const slug = useRoute().params.slug as string

const pb = useNuxtApp().$pb

const { data, error } = await useAsyncData(`page--${slug}`, async () => {
  const slugToFind = (slug === '/' || slug === '') ? 'homepage' : slug
  const filter = pb.filter(`slug = {:slug} && published = TRUE`, { slug: slugToFind })
  const data = await pb.collection('pages').getFirstListItem<Page>(filter, { expand: 'sections, sections.buttons, sections.buttons.page' })
  if (!data) {
    throw new Error('Page not found')
  }
  return data
})

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found' })
}
</script>

<template>
  <div>
    <PageFull
      v-if="data"
      :page="data"
      class="w-full overflow-x-hidden"
    />
  </div>
</template>
